import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NZ_I18N } from 'ng-zorro-antd/i18n';
import { en_US } from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { IconsProviderModule } from '../icons-provider.module';
import { SidenavComponent } from './sidenav/sidenav.component';
import { NgZorroAntdModule } from 'src/ng-zorro-antd.module'; 
import { ApiService } from './api-providers/services/api-service';
import { LoginComponent } from './login/login.component';
import { GoogleLoginProvider, SocialAuthServiceConfig, SocialLoginModule } from '@abacritt/angularx-social-login';
import { environment } from 'src/environments/environment';
import { APIServiceInterceptor } from './api-providers/interceptors/APIService.interceptor';
// import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { SharedComponentsModule } from './shared-components/shared-components.module';
 
 

registerLocaleData(en);

@NgModule({
  declarations: [
    AppComponent,
    SidenavComponent,
    LoginComponent,
  

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    IconsProviderModule,
    NgZorroAntdModule,
    SocialLoginModule,
    // NgxDocViewerModule
    InfiniteScrollModule,
    SharedComponentsModule
  ],
  providers: [
    ApiService,
    { provide: HTTP_INTERCEPTORS, useClass: APIServiceInterceptor, multi: true },
    { provide: NZ_I18N, useValue: en_US },
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(environment.google_login_provider, { oneTapEnabled: false, })
          },
        ],
        onError: (err) => {
          // console.error(err);
        }
      } as SocialAuthServiceConfig,
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }